// src/services/apis/s2Api.js

const s2Api = (apiClient) => ({
    searchMoviesOrTvShows: async (params) => {
      const response = await apiClient.get('/Download/Bartarmoviz/SearchMoviesOrTvShows', { params });
      return response.data;
    },
    getDownloadLinks: async (params) => {
      const response = await apiClient.get('/Download/Bartarmoviz/GetDownloadLinks', { params });
      return response.data;
    },
  });
  
  export default s2Api;
  